import './monacoSetup'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import { PublicClientApplication } from '@azure/msal-browser'
import { createMSALConfig } from './config/auth'
import App from './App'
import { installApiFetchAuth } from './services/apiFetchAuth'

// Every /api route requires a session (#2045); give direct fetch() calls the token.
installApiFetchAuth()

// Initialize MSAL instance
const msalConfig = createMSALConfig()
const msalInstance = msalConfig ? new PublicClientApplication(msalConfig) : null

ReactDOM.createRoot(document.getElementById('root')!).render(
  msalInstance ? (
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    ) : (
      <App />
    ),
)
